import { useState } from 'react';
import Hero from './components/Hero';
import ServiceIntro from './components/ServiceIntro';
import PricingTable from './components/PricingTable';
import PartnerBenefits from './components/PartnerBenefits';
import TargetCustomers from './components/TargetCustomers';
import ComboTour from './components/ComboTour';
import ServiceArea from './components/ServiceArea';
import Gallery from './components/Gallery';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ServiceIntro />
      <PricingTable />
      <PartnerBenefits />
      <TargetCustomers />
      <ComboTour />
      <ServiceArea />
      <Gallery />
      <ContactForm />
      <Footer />
    </div>
  );
}
